import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import DocumentDownload from "../../Entity/DocumentDownload";
import getChangeDocumentPosition from "../../DependencyInjection/changeDocumentPosition";

const ChangeDocumentPositionsListener: EventHandler<DocumentDownload[]> = async (event: IpcMainInvokeEvent, content: DocumentDownload[]): Promise<void> => {
    for (const contentDocument of content) {
        const document: DocumentDownload = DocumentDownload.from(contentDocument);
        getChangeDocumentPosition().change(document.getIdString(), document.getPosition());
    }
}

export default ChangeDocumentPositionsListener;